export default "__VITE_ASSET__6AiIIIhs__"